import _ from "lodash";

const assets = {
  _conditional: (data) => {
    return [];
  },
};

export default assets;
